import { TaskStatus } from "@common/types/task";
import { TaskColumn } from "@common/types/views/tasksView";
import {
    BoardCardTagSpokenPrefix,
    BoardCardTagTrigger,
} from "@design-system/Board/BoardCardTag";
import { StatusPill } from "@design-system/StatusPill/StatusPill";
import { TaskInProgressSpinnerIcon } from "@design-system/StatusPill/TaskInProgressSpinnerIcon";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { TASK_STATUS_CONFIG } from "../TaskStatusSelect/taskStatus.constants";
import { getTaskColumnName } from "./taskCardEdits";
import styles from "./TaskBoardCard.module.scss";

const STATUS_FIELD = getTaskColumnName(TaskColumn.STATUS);

interface TaskStatusPillProps {
    status: TaskStatus;
    className?: string;
}

/**
 * A task's status as a board card's pill, named "Status" in its tooltip and
 * before the value for screen readers, as the card's tags name their
 * fields. Statuses never animate on boards.
 */
export const TaskStatusPill = ({
    status,
    className,
}: Readonly<TaskStatusPillProps>) => {
    const { Icon, tooltip } = TASK_STATUS_CONFIG[status];
    return (
        <Tooltip content={STATUS_FIELD}>
            <BoardCardTagTrigger className={styles.statusTrigger}>
                <BoardCardTagSpokenPrefix>
                    {STATUS_FIELD}
                </BoardCardTagSpokenPrefix>
                <StatusPill
                    icon={
                        status === TaskStatus.IN_PROGRESS ? (
                            <TaskInProgressSpinnerIcon />
                        ) : (
                            <Icon aria-hidden />
                        )
                    }
                    label={tooltip}
                    className={className}
                />
            </BoardCardTagTrigger>
        </Tooltip>
    );
};
